import React from 'react';
import PropTypes from 'prop-types';

import BaseSVG from './BaseSVG';
import GlucoseYAxis from './GlucoseYAxis';
import './Dashboard.css';

function GlucoseSVG({ children, times, yTicks, width, ...rest }) {
  const yAxis = <GlucoseYAxis ticks={yTicks} width={width} />
  return (
    <BaseSVG times={times} yAxis={yAxis} yAxisTop={true} width={width} {...rest} >
      {children}
    </BaseSVG>
  );
}

GlucoseSVG.propTypes = {
  children: PropTypes.node,
  times: BaseSVG.propTypes.times,
  width: BaseSVG.propTypes.width,
};


GlucoseSVG.defaultProps = {
  children: undefined,
  times: undefined,
  width: undefined,
};

export default GlucoseSVG;
